import { render } from "./KsImg.vue?vue&type=template&id=6835d7da&scoped=true"
import script from "./KsImg.vue?vue&type=script&lang=js"
export * from "./KsImg.vue?vue&type=script&lang=js"

import "./KsImg.vue?vue&type=style&index=0&id=6835d7da&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6835d7da"]])

export default __exports__